import { createSlice } from '@reduxjs/toolkit';

const loadInitialState =  ()=>{
  const user = localStorage.getItem('trp_usr');
  const token = localStorage.getItem('trp_tk');

  let parsedUser = null;
  let isVerified = false;

  if(user){
    try{
      parsedUser= JSON.parse(user);
      isVerified =!!(parsedUser?.email_verified_at || parsedUser?.phone_number_verified_at);

    }catch(error){
      console.error("Error parsing user from localStorage:", error);
      localStorage.removeItem('trp_usr');
    }
  }
  return {
    isAuth: !!token,
    isVrf: isVerified,
    trp_usr: parsedUser,
    trp_tk: token || null,
  }

  
}
const initialState = loadInitialState();

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, action) {
      state.isAuth = true;
      if (action.payload) {
        state.trp_usr = action.payload;
        state.isVrf = !!(action.payload?.email_verified_at || action.payload?.phone_number_verified_at);
      }
      localStorage.setItem('trp_usr', JSON.stringify(action.payload));
      if (action.payload?.token) {
        localStorage.setItem('trp_tk', action.payload.token);
      }
    },
    setNewUser(state, action) {
      state.isAuth = true;
      state.isVrf = false;
      state.trp_usr = action.payload;
      localStorage.setItem('trp_usr', JSON.stringify(action.payload));
    },
    setToken(state, action) {
      const token = action.payload;
      if(action.payload){
        localStorage.setItem("trp_tk", token);
      }
      state.isAuth = !!action.payload;
      if(action.payload && !state.trp_usr){
        const user = localStorage.getItem('trp_usr');
        if(user){
          try{
            state.trp_usr = JSON.parse(user);
            state.isVrf = !!(state.trp_usr?.email_verified_at || state.trp_usr?.phone_number_verified_at);
          }catch(error){
            console.error("Error parsing user from localStorage:", error);
          }
        }
      }
    },
    clearAuth(state){
      state.isAuth = false;
      state.isVrf = false;
      state.trp_usr = null;
      state.trp_tk = null;
      localStorage.removeItem('trp_usr');
      localStorage.removeItem('trp_tk');
    }
    
  },
});

export const { setUser, setNewUser, setToken, clearAuth } = authSlice.actions;
export default authSlice.reducer;



